// Port of src/features/market/format.ts. The two `_`-prefixed helpers next to them in
// the Next file are knip-dead and are not ported.

const BANANA = '🍌';

/**
 * Price of a share, in bananas (each winning share pays 1 🍌).
 * Defaults to 2-decimal precision; pass digits for more/less.
 */
export function formatPrice(p: number, digits = 2): string {
  return `${p.toFixed(digits)} ${BANANA}`;
}

/**
 * Same number as formatPrice, but framed as implied probability.
 * Defaults to 1-decimal percent: 0.0357 -> "3.6%".
 */
export function formatPercent(p: number, digits = 1): string {
  return `${(p * 100).toFixed(digits)}%`;
}

// A banana amount: 1234 -> "1,234 🍌".
export function formatBananas(n: number): string {
  return `${n.toLocaleString()} ${BANANA}`;
}

// A gain or loss, signed either way: 12 -> "+12", -3 -> "-3".
export function formatSigned(n: number, suffix = ''): string {
  return `${n >= 0 ? '+' : ''}${n.toLocaleString()}${suffix}`;
}
